import { createMuiTheme } from '@material-ui/core/styles'

let theme = createMuiTheme({
  palette: {
    primary: {
      light: '#fff',
      main: '#fff',
      dark: '#fff',
      contrastText: '#0e1d28',
    },
    secondary: {
      light: '#000',
      main: '#000',
      dark: '#000',
      contrastText: '#0e1d28',
    },
  },
  typography: {
    fontFamily: '"Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  },
})

theme = {
  ...theme,
  overrides: {
    MuiTableCell: {
      paddingNone: {
        padding: '4px 10px',
      },
    },
    MuiInputLabel: {
      root: {
        color: '#000',
        '&$focused': {
          color: '#009696',
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
        textTransform: 'none',
        backgroundColor: '#e20015',
      },
      contained: {
        backgroundColor: '#e20015',
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
      },
      selected: {
        color: theme.palette.primary.dark,
      },
      textColorPrimary: {
        color: '#878787',
      },
    },
    MuiTabs: {
      root: {
        boxShadow: '0 1px 2px 0 rgba(221,221,221,0.5)',
      },
      indicator: {
        height: 5,
      },
    },
    MuiTypography: {
      colorSecondary: {
        color: '#000',
      },
      colorTextSecondary: {
        color: '#000',
        fontWeight: 500,
      },
      colorError: {
        color: '#e20015',
      },
      h1: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 20,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 40,
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: 50,
        },
      },
      h2: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 18,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 35,
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: 40,
        },
      },
      h3: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 14,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 16,
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: 18,
        },
      },
      h4: {
        fontWeight: 500,
        [theme.breakpoints.down('sm')]: {
          fontSize: 12,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 14,
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: 16,
        },
      },
      h5: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 12,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 14,
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: 16,
        },
      },
      h6: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 12,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 14,
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: 16,
        },
      },
      body1: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 12,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 16,
        },
      },
    },
  },
}

export default theme
